import { render, staticRenderFns } from "./categoryPosts.vue?vue&type=template&id=0f779068&"
import script from "./categoryPosts.vue?vue&type=script&lang=js&"
export * from "./categoryPosts.vue?vue&type=script&lang=js&"
import style0 from "./categoryPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports